import { render, staticRenderFns } from "./BaseButtonDropdown.vue?vue&type=template&id=42953ca6&"
import script from "./BaseButtonDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseButtonDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButtonDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown,QBtn});
